<template>
    <div class="site-navbar-wrapper">
        <nav class="site-navbar" id="site-navbar">
            <div class="site-a" v-bind:class="{ navOpen: navOpen }">
                <a href="http://giordano-courtage.com" class="courtage-link">Giordano Courtage</a>
                <a href="http://giordano-immobilier.com" class="immobilier-link">Giordano Immobilier</a>
                <a href="http://giordano-patrimoine.com" class="patrimoine-link">Giordano Patrimoine</a>
            </div>
            <button class="dropdown-btn" v-on:click="(navOpen = !navOpen)" v-bind:class="{ active: navOpen }">
                <a class="active">{{ activeSite }}</a>
                <img class="dropdown-icon" src="../../assets/icons/icn-select-24-px-little.svg" />
            </button>
        </nav>
    </div>
</template>

<script>

export default {
    name: "SiteNavbar",
    props: {
        activeSite: String
    },
    data: () => {
        return {
            navOpen: false
        }
    }
}
</script>

<style lang="scss">
.site-navbar-wrapper {
    height: 46px;
    width: 100%;
    background-color: #000;
    display: flex;
    justify-content: center;
}

.site-navbar {
    width: var(--max-width);
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .site-a {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        background-color: #000;
    }

    a {
        margin: 0 20px 0 20px;
        font-size: var(--font-size-small);
        color: #fff !important;

        &.router-link-active {
            color: var(--color-primary) !important;
            font-weight: 600;
            cursor: default;
            text-decoration: none;
            color: white;

            &:hover {
                text-decoration: none;
                color: white;
                
            }
        }
    }

    .dropdown-btn {
        display: none;
        color: #ffb402 !important;
        background: black;
        align-items: center;
        width: auto;
        min-width: 0;
        margin-right: 16px;
        padding: 0;
        border: none;
    }
}

@media (max-width: 720px) {
    .site-navbar {
        padding-right: 0px;
        justify-content: flex-start;
    }
}

@media (max-width: 570px) {
    .site-navbar {
        justify-content: flex-end;

        .dropdown-btn {
            display: flex;

            .dropdown-icon {
                transform: rotate(0deg);
                transition: transform .5s cubic-bezier(.77, .2, .05, 1);
            }
        }

        .dropdown-btn.active {
            .dropdown-icon {
                transform: rotate(180deg);
                transition: transform .5s cubic-bezier(.77, .2, .05, 1);
            }
        }

        .site-a {
            z-index: 99;
            position: absolute;
            right: 40px;
            top: -170px;
            flex-direction: column;
            align-items: flex-start;
            padding: 12px;
            border-radius: 8px;
            transform-origin: 0% 0%;
            transform: translate(0%, 0%);
            transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0);

            &.navOpen {
                transform-origin: 0% 0%;
                transform: translate(0%, 150%);
                transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0);
            }

            a {
                margin: 10px 0 10px 0;
            }
        }
    }
}
</style>